import React from "react";

type PropsType = {
  style?: React.CSSProperties;
  size?: number;
};

const MikaBot = ({ size = 103, style = {} }: PropsType) => {
  return (
    <svg
      width="103"
      height="101"
      viewBox="0 0 103 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3971_17471)">
        <ellipse
          cx="45.5696"
          cy="45.5696"
          rx="45.5696"
          ry="45.5696"
          transform="matrix(-1 0 0 1 102.532 0.87207)"
          fill="#5DF5C9"
        />
        <ellipse cx="37.975" cy="41.3783" rx="8.86076" ry="8.86076" fill="white" />
        <ellipse cx="37.9749" cy="41.3784" rx="6.32911" ry="6.32911" fill="#003125" />
        <ellipse cx="75.9496" cy="41.3783" rx="8.86076" ry="8.86076" fill="white" />
        <ellipse cx="75.9495" cy="41.3784" rx="6.32911" ry="6.32911" fill="#003125" />
        <path
          d="M64.5571 88.2139V100.872H72.1521"
          stroke="#003125"
          stroke-width="2.53165"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M49.3674 88.2139V100.872H41.7725"
          stroke="#003125"
          stroke-width="2.53165"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M75.3165 62.8975C56.9621 71.1253 38.6076 62.8975 38.6076 62.8975C38.1857 69.2266 38.6076 83.7835 42.4051 88.8468C46.2026 93.9101 67.7216 92.0114 73.4178 89.4797C75.9494 81.8848 75.3165 75.5557 75.3165 62.8975Z"
          fill="white"
        />
        <path
          d="M102.025 54.0366C96.3293 81.8847 75.8651 89.4797 67.2153 91.3784V70.4923L75.4432 62.8974C92.5318 63.5303 96.5402 58.256 102.025 54.0366Z"
          fill="#F2F2F3"
        />
        <path
          d="M11.8989 54.0366C17.5951 81.8847 38.0592 89.4797 46.709 91.3784V70.4923L38.4811 62.8974C21.3925 63.5303 17.3841 58.256 11.8989 54.0366Z"
          fill="#F2F2F3"
        />
        <path
          d="M86.709 86.948L91.1394 74.2898L86.0895 65.429"
          stroke="#003125"
          stroke-width="2.53165"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="25.3167"
          y="31.2517"
          width="26.5823"
          height="20.2532"
          rx="5.06329"
          stroke="#003125"
          stroke-width="3.16456"
          stroke-linejoin="round"
        />
        <path d="M50.6331 41.3784H63.9242" stroke="#003125" stroke-width="3.16456" />
        <rect
          x="63.2913"
          y="31.2517"
          width="26.5823"
          height="20.2532"
          rx="5.06329"
          stroke="#003125"
          stroke-width="3.16456"
          stroke-linejoin="round"
        />
        <path d="M50.6328 66.6948H63.291L61.1813 74.2898H52.7425L50.6328 66.6948Z" fill="#94979E" />
        <path
          d="M54.4304 74.2898H59.4937L60.7595 89.4797L56.962 93.2771L53.1646 89.4797L54.4304 74.2898Z"
          fill="#94979E"
        />
        <rect
          x="72.1519"
          y="71.7581"
          width="12.6582"
          height="6.32911"
          rx="1.26582"
          fill="#94979E"
        />
        <path
          d="M17.9319 65.7771L7.55542 56.7914L5.84105 45.176"
          stroke="#003125"
          stroke-width="2.53165"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3971_17471">
          <rect width="103" height="100" fill="white" transform="translate(0 0.87207)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MikaBot;
